import type { PdfComponentWhitespaceI } from '../typed';

const TermsAndConditionsRenderWhitespace: React.FunctionComponent<PdfComponentWhitespaceI> =
  function ({ height }) {
    return (
      <div
        style={{
          height: `${height}px`,
          minHeight: `${height}px`,
          maxHeight: `${height}px`,
        }}
      />
    );
  };

export default TermsAndConditionsRenderWhitespace;
